"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }



var _myRelations = require('shared/selectors/myRelations');
var _session = require('shared/selectors/session');

/* The team a new campaign starts with: the selected team when it's one of my
 * phone teams, else my first phone team. Details preselects it and the
 * sidebar's draft row shows it, so the two can't disagree. */
 const selectDefaultCampaignTeamKey = (state) => {
  const {
    teamsList,
    entitiesMap,
  } = _myRelations.selectMyPhoneTeamEntities.call(void 0, state) 



  return [_session.selectSelectedTeamKey.call(void 0, state)].find(k => k && entitiesMap[k])
    || _optionalChain([teamsList, 'access', _ => _[0], 'optionalAccess', _2 => _2.wrappedEntity, 'optionalAccess', _3 => _3.TeamKey])
    || null
}; exports.selectDefaultCampaignTeamKey = selectDefaultCampaignTeamKey
